var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolsCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 7.5H15.8337M12.5003 15V12.5M7.50033 15H7.50866M10.0003 15H10.0087M10.0003 12.5H10.0087M7.50033 12.5H7.50866M12.5003 10H12.5087M10.0003 10H10.0087M7.50033 10H7.50866M6.83366 17.5H13.167C14.1004 17.5 14.5671 17.5 14.9236 17.3183C15.2372 17.1586 15.4922 16.9036 15.652 16.59C15.8337 16.2335 15.8337 15.7668 15.8337 14.8333V5.16667C15.8337 4.23325 15.8337 3.76654 15.652 3.41002C15.4922 3.09641 15.2372 2.84144 14.9236 2.68166C14.5671 2.5 14.1004 2.5 13.167 2.5H6.83366C5.90024 2.5 5.43353 2.5 5.07701 2.68166C4.7634 2.84144 4.50844 3.09641 4.34865 3.41002C4.16699 3.76654 4.16699 4.23325 4.16699 5.16667V14.8333C4.16699 15.7668 4.16699 16.2335 4.34865 16.59C4.50844 16.9036 4.7634 17.1586 5.07701 17.3183C5.43353 17.5 5.90024 17.5 6.83366 17.5Z",
    stroke: "#857DFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolsCalculatorIcon);
export default __webpack_public_path__ + "static/media/poolsCalculatorIcon.d6b95806b53002d4e0dc3c9e23d613b5.svg";
export { ForwardRef as ReactComponent };